




















import {Component, Vue, Prop} from 'vue-property-decorator';
import SignalDiagramBox from '@c/diagrams/SignalDiagramBox.vue';
import {DiagramData} from '@c/diagrams/interfaces';
import CompareDiagramButtonDialog from '@/components/services/diagnosticAssistance/CompareDiagramButtonDialog.vue';

@Component({
  components: {
    SignalDiagramBox,
    CompareDiagramButtonDialog,
  },
})
export default class DAssistanceSignalDiagramBox extends Vue {
  // Текущая диаграмма
  @Prop({required: true})
  diagram!: DiagramData;

  // Список диаграмм для сравнения
  @Prop({required: true})
  diagrams!: DiagramData[];

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  // Список выбранных диаграмм
  selectedDiagrams: DiagramData[] = [];

  //Действия при выборе программных модулей
  onSelect(diagramIds: string[]) {
    this.selectedDiagrams = this.diagrams.filter(x => diagramIds.includes(x.id));
  }
}
